import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : parts for managing types
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
import { useApi, useSelector, useState, usePersistent, usePhysicalNode, useMemo } from 'uix/hooks';
import { HeaderSegment, XMenu, DebugFeature } from 'uix/components';
import { SearchableJSONTree } from 'uix/chunks';
import { Sel } from 'uix/registries';
// ---Local imports
import { TypesConfigTable, DatatypeConfigTable, TypeCaption } from './components';
import { useFullTypeConfig } from './hooks';
// ---Exports
export const TypesConfig = ({})=>{
    let [debug, setDebug] = useState(false);
    let { id } = useSelector(Sel.request);
    let [query, setQuery] = usePersistent('typesCfgQuery', '');
    let [hideEmptyCounts, setHideEmptyCounts] = usePersistent('hideEmptyCounts', false);
    let { typescfg: data, loading } = useFullTypeConfig();
    // s2wp~byType~letter
    //~ let typeName = id?.split('~').slice(-1)[0]
    let datatypeName = 'metadata';
    let content = null;
    if (!loading) {
        if (debug) {
            //~ let dbgData = data?.metadata[typeName] || data?.metadata || ''
            content = /*#__PURE__*/ _jsx(SearchableJSONTree, {
                hideRoot: true,
                data: data,
                query: query
            });
        } else {
            content = /*#__PURE__*/ _jsx(TypesConfigTable, {
                query: query,
                datatypeName: datatypeName,
                xdtypes: data,
                withCounts: true,
                hideEmptyCounts: hideEmptyCounts
            });
        }
    }
    //~ }
    let menu = /*#__PURE__*/ _jsxs(XMenu, {
        children: [
            /*#__PURE__*/ _jsx(XMenu.Input, {
                icon: "search",
                onEnterKey: setQuery,
                debounce: 1000,
                defaultValue: query,
                onValueChange: (value)=>setQuery(value),
                title: "query config value like 'pdf' or 'mets'"
            }),
            /*#__PURE__*/ _jsx(XMenu.Toggle, {
                icon: "circle outline",
                title: "hide types with count=0",
                set: setHideEmptyCounts,
                value: hideEmptyCounts
            }),
            /*#__PURE__*/ _jsx(DebugFeature, {
                children: /*#__PURE__*/ _jsx(XMenu.Toggle, {
                    icon: "bug",
                    set: setDebug,
                    value: debug
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsx(HeaderSegment, {
        major: true,
        header: "Types",
        subheader: datatypeName,
        icon: "configure",
        menu: menu,
        loading: loading,
        overflowInner: true,
        flexInner: true,
        flex: true,
        children: content
    });
};
export const TypeConfig = ({ i18n })=>{
    let { typescfg, loading } = useFullTypeConfig();
    let node = usePhysicalNode();
    let type_name = node.type;
    let dtcfg = typescfg?.[node.datatypeName]?.[type_name];
    let request = useSelector(Sel.request);
    if (node.datatypeName == 'domain') {
        type_name = request.id.split('~').slice(-1)[0];
        dtcfg = typescfg?.['metadata']?.[type_name];
    }
    return /*#__PURE__*/ _jsx(HeaderSegment, {
        major: true,
        header: "Konfiguration",
        subheader: /*#__PURE__*/ _jsx(TypeCaption, {
            width: 12,
            name: type_name,
            caption: `${i18n.getType(type_name)} (${type_name})`
        }),
        icon: "configure",
        menu: null,
        loading: loading,
        children: /*#__PURE__*/ _jsx(DatatypeConfigTable, {
            dtcfg: dtcfg
        })
    });
};
